import { put, all, call, select, takeEvery, takeLatest, fork, cancel } from 'redux-saga/effects';
import { exception } from 'circe/logger';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import moment from 'moment';
import {
  fetch,
  fetching,
  fetched,
  failed,
  createBatch,
  createdBatch,
  createBatchFailed,
} from './actions';
import * as api from './api';

function* doFetch(context, { payload }) {
  try {
    const { fileName, params = {} } = payload;

    const { shipperId, pickupAddress, returnAddress, pickupDate } = params;

    yield put(fetching());

    const results = yield call(api.fetch, {
      batchFileName: fileName,
      profileId: shipperId,

      pickupDestination: {
        arrivalWindow: {
          begin: moment(pickupDate),
          end: moment(pickupDate).add(2, 'hours'),
          excludeBegin: true,
          excludeEnd: true,
        },
        duration: 1800,
        location: {
          ...pickupAddress,
          description: pickupAddress.address,
          identifier: pickupAddress.address,
        },
      },
      returnToDestination: {
        arrivalWindow: {
          begin: moment(pickupDate).add(1, 'day'),
          end: moment(pickupDate)
            .add(1, 'day')
            .add(2, 'hours'),
          excludeBegin: true,
          excludeEnd: true,
        },
        duration: 1800,
        location: {
          ...returnAddress,
          description: pickupAddress.address,
          identifier: pickupAddress.address,
        },
      },
    });

    if (!results) {
      throw new Error(`Failed to parse shipments for the following file ${fileName}`);
    }

    localStorage.setItem(
      'BATCH_SHIPMENTS',
      JSON.stringify({ [results.quoteIds[0]]: { ...results, shipperId } }),
    );
    yield put(
      showNotification(
        I18n.str('shipmentsCreatedSuces', 'Shipments created successfully'),
        'success',
      ),
    );

    yield put(fetched({ ...results, shipperId }));
    context.history.push('/shipments');
  } catch (e) {
    yield put(failed(e));
    console.error(e);

    let message = I18n.str('unableToParseFiles', 'Unable to parse excel file.');
    if (e.code === 400) {
      message = e.response?.message || e.response?.error || message;
    }

    yield put(showNotification(message, 'error'));
    exception(e);
  }
}

function* doCreateBatch(context, action) {
  try {
    const {
      payload: { shipments },
    } = action;

    if (shipments.length === 0) {
      return;
    }

    const resp = yield call(api.create, shipments);

    if (!resp) {
      throw new Error('Unable to assign shipments');
    }

    if (resp.length === 0) {
      yield put(
        showNotification(I18n.str('createBatchFailed', 'Unable to create batch.'), 'error'),
      );
      yield put(createBatchFailed());
      return;
    }

    localStorage.setItem('BATCH_RESPONSE', JSON.stringify(resp));
    yield put(
      showNotification(
        I18n.str('shipmentsAssigned', '{count} Shipments assigned successfully.', {
          count: resp.lenght,
        }),
        'success',
      ),
    );
    yield put(createdBatch(resp));
  } catch (e) {
    yield put(createBatchFailed());
    exception(e);

    let message = I18n.str('createBatchFailed', 'Unable to assign shipments.');
    if (e.code && e.code.status === 400) {
      message = e.code?.message || e.code?.error || message;
    }

    yield put(showNotification(message, 'error'));
  }
}

export default function*(context) {
  yield all([
    takeEvery(fetch().type, doFetch, context),
    takeEvery(createBatch().type, doCreateBatch, context),
  ]);
}
